/**
 * Country centroids — static map of ISO 3166-1 alpha-2 codes to [lat, lng].
 * Used by GDELT, sanctions, and Polymarket for geo-positioning events
 * that only have country-level location data.
 *
 * ~195 countries with approximate geographic center coordinates.
 */

const CENTROIDS: Record<string, [number, number]> = {
  AF: [33.94, 67.71],    // Afghanistan
  AL: [41.15, 20.17],    // Albania
  DZ: [28.03, 1.66],     // Algeria
  AD: [42.55, 1.60],     // Andorra
  AO: [-11.20, 17.87],   // Angola
  AG: [17.06, -61.80],   // Antigua and Barbuda
  AR: [-38.42, -63.62],  // Argentina
  AM: [40.07, 45.04],    // Armenia
  AU: [-25.27, 133.78],  // Australia
  AT: [47.52, 14.55],    // Austria
  AZ: [40.14, 47.58],    // Azerbaijan
  BS: [25.03, -77.40],   // Bahamas
  BH: [26.07, 50.56],    // Bahrain
  BD: [23.68, 90.36],    // Bangladesh
  BB: [13.19, -59.54],   // Barbados
  BY: [53.71, 27.95],    // Belarus
  BE: [50.50, 4.47],     // Belgium
  BZ: [17.19, -88.50],   // Belize
  BJ: [9.31, 2.32],      // Benin
  BT: [27.51, 90.43],    // Bhutan
  BO: [-16.29, -63.59],  // Bolivia
  BA: [43.92, 17.68],    // Bosnia and Herzegovina
  BW: [-22.33, 24.68],   // Botswana
  BR: [-14.24, -51.93],  // Brazil
  BN: [4.54, 114.73],    // Brunei
  BG: [42.73, 25.49],    // Bulgaria
  BF: [12.24, -1.56],    // Burkina Faso
  BI: [-3.37, 29.92],    // Burundi
  KH: [12.57, 104.99],   // Cambodia
  CM: [7.37, 12.35],     // Cameroon
  CA: [56.13, -106.35],  // Canada
  CV: [16.00, -24.01],   // Cape Verde
  CF: [6.61, 20.94],     // Central African Republic
  TD: [15.45, 18.73],    // Chad
  CL: [-35.68, -71.54],  // Chile
  CN: [35.86, 104.20],   // China
  CO: [4.57, -74.30],    // Colombia
  KM: [-11.88, 43.87],   // Comoros
  CG: [-0.23, 15.83],    // Congo
  CD: [-4.04, 21.76],    // DR Congo
  CR: [9.75, -83.75],    // Costa Rica
  CI: [7.54, -5.55],     // Côte d'Ivoire
  HR: [45.10, 15.20],    // Croatia
  CU: [21.52, -77.78],   // Cuba
  CY: [35.13, 33.43],    // Cyprus
  CZ: [49.82, 15.47],    // Czech Republic
  DK: [56.26, 9.50],     // Denmark
  DJ: [11.83, 42.59],    // Djibouti
  DM: [15.41, -61.37],   // Dominica
  DO: [18.74, -70.16],   // Dominican Republic
  EC: [-1.83, -78.18],   // Ecuador
  EG: [26.82, 30.80],    // Egypt
  SV: [13.79, -88.90],   // El Salvador
  GQ: [1.65, 10.27],     // Equatorial Guinea
  ER: [15.18, 39.78],    // Eritrea
  EE: [58.60, 25.01],    // Estonia
  SZ: [-26.52, 31.47],   // Eswatini
  ET: [9.15, 40.49],     // Ethiopia
  FJ: [-17.71, 178.07],  // Fiji
  FI: [61.92, 25.75],    // Finland
  FR: [46.23, 2.21],     // France
  GA: [-0.80, 11.61],    // Gabon
  GM: [13.44, -15.31],   // Gambia
  GE: [42.32, 43.36],    // Georgia
  DE: [51.17, 10.45],    // Germany
  GH: [7.95, -1.02],     // Ghana
  GR: [39.07, 21.82],    // Greece
  GD: [12.26, -61.60],   // Grenada
  GT: [15.78, -90.23],   // Guatemala
  GN: [9.95, -9.70],     // Guinea
  GW: [11.80, -15.18],   // Guinea-Bissau
  GY: [4.86, -58.93],    // Guyana
  HT: [18.97, -72.29],   // Haiti
  HN: [15.20, -86.24],   // Honduras
  HU: [47.16, 19.50],    // Hungary
  IS: [64.96, -19.02],   // Iceland
  IN: [20.59, 78.96],    // India
  ID: [-0.79, 113.92],   // Indonesia
  IR: [32.43, 53.69],    // Iran
  IQ: [33.22, 43.68],    // Iraq
  IE: [53.14, -7.69],    // Ireland
  IL: [31.05, 34.85],    // Israel
  IT: [41.87, 12.57],    // Italy
  JM: [18.11, -77.30],   // Jamaica
  JP: [36.20, 138.25],   // Japan
  JO: [30.59, 36.24],    // Jordan
  KZ: [48.02, 66.92],    // Kazakhstan
  KE: [-0.02, 37.91],    // Kenya
  KI: [-3.37, -168.73],  // Kiribati
  KP: [40.34, 127.51],   // North Korea
  KR: [35.91, 127.77],   // South Korea
  KW: [29.31, 47.48],    // Kuwait
  KG: [41.20, 74.77],    // Kyrgyzstan
  LA: [19.86, 102.50],   // Laos
  LV: [56.88, 24.60],    // Latvia
  LB: [33.85, 35.86],    // Lebanon
  LS: [-29.61, 28.23],   // Lesotho
  LR: [6.43, -9.43],     // Liberia
  LY: [26.34, 17.23],    // Libya
  LI: [47.17, 9.56],     // Liechtenstein
  LT: [55.17, 23.88],    // Lithuania
  LU: [49.82, 6.13],     // Luxembourg
  MG: [-18.77, 46.87],   // Madagascar
  MW: [-13.25, 34.30],   // Malawi
  MY: [4.21, 101.98],    // Malaysia
  MV: [3.20, 73.22],     // Maldives
  ML: [17.57, -4.00],    // Mali
  MT: [35.94, 14.38],    // Malta
  MH: [7.13, 171.18],    // Marshall Islands
  MR: [21.01, -10.94],   // Mauritania
  MU: [-20.35, 57.55],   // Mauritius
  MX: [23.63, -102.55],  // Mexico
  FM: [7.43, 150.55],    // Micronesia
  MD: [47.41, 28.37],    // Moldova
  MC: [43.75, 7.41],     // Monaco
  MN: [46.86, 103.85],   // Mongolia
  ME: [42.71, 19.37],    // Montenegro
  MA: [31.79, -7.09],    // Morocco
  MZ: [-18.67, 35.53],   // Mozambique
  MM: [21.91, 95.96],    // Myanmar
  NA: [-22.96, 18.49],   // Namibia
  NR: [-0.52, 166.93],   // Nauru
  NP: [28.39, 84.12],    // Nepal
  NL: [52.13, 5.29],     // Netherlands
  NZ: [-40.90, 174.89],  // New Zealand
  NI: [12.87, -85.21],   // Nicaragua
  NE: [17.61, 8.08],     // Niger
  NG: [9.08, 8.68],      // Nigeria
  MK: [41.51, 21.75],    // North Macedonia
  NO: [60.47, 8.47],     // Norway
  OM: [21.47, 55.98],    // Oman
  PK: [30.38, 69.35],    // Pakistan
  PW: [7.51, 134.58],    // Palau
  PS: [31.95, 35.23],    // Palestine
  PA: [8.54, -80.78],    // Panama
  PG: [-6.31, 143.96],   // Papua New Guinea
  PY: [-23.44, -58.44],  // Paraguay
  PE: [-9.19, -75.02],   // Peru
  PH: [12.88, 121.77],   // Philippines
  PL: [51.92, 19.15],    // Poland
  PT: [39.40, -8.22],    // Portugal
  QA: [25.35, 51.18],    // Qatar
  RO: [45.94, 24.97],    // Romania
  RU: [61.52, 105.32],   // Russia
  RW: [-1.94, 29.87],    // Rwanda
  KN: [17.36, -62.78],   // Saint Kitts and Nevis
  LC: [13.91, -60.98],   // Saint Lucia
  VC: [12.98, -61.29],   // Saint Vincent
  WS: [-13.76, -172.10], // Samoa
  SM: [43.94, 12.46],    // San Marino
  ST: [0.19, 6.61],      // Sao Tome and Principe
  SA: [23.89, 45.08],    // Saudi Arabia
  SN: [14.50, -14.45],   // Senegal
  RS: [44.02, 21.01],    // Serbia
  SC: [-4.68, 55.49],    // Seychelles
  SL: [8.46, -11.78],    // Sierra Leone
  SG: [1.35, 103.82],    // Singapore
  SK: [48.67, 19.70],    // Slovakia
  SI: [46.15, 14.99],    // Slovenia
  SB: [-9.65, 160.16],   // Solomon Islands
  SO: [5.15, 46.20],     // Somalia
  ZA: [-30.56, 22.94],   // South Africa
  SS: [6.88, 31.31],     // South Sudan
  ES: [40.46, -3.75],    // Spain
  LK: [7.87, 80.77],     // Sri Lanka
  SD: [12.86, 30.22],    // Sudan
  SR: [3.92, -56.03],    // Suriname
  SE: [60.13, 18.64],    // Sweden
  CH: [46.82, 8.23],     // Switzerland
  SY: [34.80, 38.99],    // Syria
  TW: [23.70, 120.96],   // Taiwan
  TJ: [38.86, 71.28],    // Tajikistan
  TZ: [-6.37, 34.89],    // Tanzania
  TH: [15.87, 100.99],   // Thailand
  TL: [-8.87, 125.73],   // Timor-Leste
  TG: [8.62, 1.21],      // Togo
  TO: [-21.18, -175.20], // Tonga
  TT: [10.69, -61.22],   // Trinidad and Tobago
  TN: [33.89, 9.54],     // Tunisia
  TR: [38.96, 35.24],    // Turkey
  TM: [38.97, 59.56],    // Turkmenistan
  TV: [-7.11, 177.65],   // Tuvalu
  UG: [1.37, 32.29],     // Uganda
  UA: [48.38, 31.17],    // Ukraine
  AE: [23.42, 53.85],    // UAE
  GB: [55.38, -3.44],    // United Kingdom
  US: [37.09, -95.71],   // United States
  UY: [-32.52, -55.77],  // Uruguay
  UZ: [41.38, 64.59],    // Uzbekistan
  VU: [-15.38, 166.96],  // Vanuatu
  VA: [41.90, 12.45],    // Vatican City
  VE: [6.42, -66.59],    // Venezuela
  VN: [14.06, 108.28],   // Vietnam
  YE: [15.55, 48.52],    // Yemen
  ZM: [-13.13, 27.85],   // Zambia
  ZW: [-19.02, 29.15],   // Zimbabwe
  XK: [42.60, 20.90],    // Kosovo
};

/**
 * Common country name aliases → ISO alpha-2 code.
 * Used for fuzzy matching from data sources that use full names or variants.
 */
const NAME_TO_CODE: Record<string, string> = {
  'afghanistan': 'AF', 'albania': 'AL', 'algeria': 'DZ', 'angola': 'AO',
  'argentina': 'AR', 'armenia': 'AM', 'australia': 'AU', 'austria': 'AT',
  'azerbaijan': 'AZ', 'bahrain': 'BH', 'bangladesh': 'BD', 'belarus': 'BY',
  'belgium': 'BE', 'benin': 'BJ', 'bhutan': 'BT', 'bolivia': 'BO',
  'bosnia': 'BA', 'bosnia and herzegovina': 'BA', 'botswana': 'BW',
  'brazil': 'BR', 'brunei': 'BN', 'bulgaria': 'BG', 'burkina faso': 'BF',
  'burundi': 'BI', 'cambodia': 'KH', 'cameroon': 'CM', 'canada': 'CA',
  'central african republic': 'CF', 'chad': 'TD', 'chile': 'CL', 'china': 'CN',
  'colombia': 'CO', 'congo': 'CG', 'costa rica': 'CR', 'croatia': 'HR',
  'cuba': 'CU', 'cyprus': 'CY', 'czech republic': 'CZ', 'czechia': 'CZ',
  'democratic republic of the congo': 'CD', 'dr congo': 'CD', 'drc': 'CD',
  'denmark': 'DK', 'djibouti': 'DJ', 'dominican republic': 'DO',
  'ecuador': 'EC', 'egypt': 'EG', 'el salvador': 'SV', 'eritrea': 'ER',
  'estonia': 'EE', 'eswatini': 'SZ', 'swaziland': 'SZ', 'ethiopia': 'ET',
  'fiji': 'FJ', 'finland': 'FI', 'france': 'FR', 'gabon': 'GA',
  'gambia': 'GM', 'georgia': 'GE', 'germany': 'DE', 'ghana': 'GH',
  'greece': 'GR', 'guatemala': 'GT', 'guinea': 'GN', 'guyana': 'GY',
  'haiti': 'HT', 'honduras': 'HN', 'hungary': 'HU', 'iceland': 'IS',
  'india': 'IN', 'indonesia': 'ID', 'iran': 'IR', 'iraq': 'IQ',
  'ireland': 'IE', 'israel': 'IL', 'italy': 'IT', 'ivory coast': 'CI',
  "cote d'ivoire": 'CI', 'jamaica': 'JM', 'japan': 'JP', 'jordan': 'JO',
  'kazakhstan': 'KZ', 'kenya': 'KE', 'north korea': 'KP', 'south korea': 'KR',
  'korea': 'KR', 'kuwait': 'KW', 'kyrgyzstan': 'KG', 'laos': 'LA',
  'latvia': 'LV', 'lebanon': 'LB', 'lesotho': 'LS', 'liberia': 'LR',
  'libya': 'LY', 'lithuania': 'LT', 'luxembourg': 'LU', 'madagascar': 'MG',
  'malawi': 'MW', 'malaysia': 'MY', 'mali': 'ML', 'malta': 'MT',
  'mauritania': 'MR', 'mauritius': 'MU', 'mexico': 'MX', 'moldova': 'MD',
  'mongolia': 'MN', 'montenegro': 'ME', 'morocco': 'MA', 'mozambique': 'MZ',
  'myanmar': 'MM', 'burma': 'MM', 'namibia': 'NA', 'nepal': 'NP',
  'netherlands': 'NL', 'new zealand': 'NZ', 'nicaragua': 'NI', 'niger': 'NE',
  'nigeria': 'NG', 'north macedonia': 'MK', 'macedonia': 'MK', 'norway': 'NO',
  'oman': 'OM', 'pakistan': 'PK', 'palestine': 'PS', 'panama': 'PA',
  'papua new guinea': 'PG', 'paraguay': 'PY', 'peru': 'PE', 'philippines': 'PH',
  'poland': 'PL', 'portugal': 'PT', 'qatar': 'QA', 'romania': 'RO',
  'russia': 'RU', 'russian federation': 'RU', 'rwanda': 'RW',
  'saudi arabia': 'SA', 'senegal': 'SN', 'serbia': 'RS', 'sierra leone': 'SL',
  'singapore': 'SG', 'slovakia': 'SK', 'slovenia': 'SI', 'somalia': 'SO',
  'south africa': 'ZA', 'south sudan': 'SS', 'spain': 'ES', 'sri lanka': 'LK',
  'sudan': 'SD', 'suriname': 'SR', 'sweden': 'SE', 'switzerland': 'CH',
  'syria': 'SY', 'taiwan': 'TW', 'tajikistan': 'TJ', 'tanzania': 'TZ',
  'thailand': 'TH', 'timor-leste': 'TL', 'east timor': 'TL', 'togo': 'TG',
  'trinidad and tobago': 'TT', 'tunisia': 'TN', 'turkey': 'TR', 'turkiye': 'TR',
  'turkmenistan': 'TM', 'uganda': 'UG', 'ukraine': 'UA',
  'united arab emirates': 'AE', 'uae': 'AE',
  'united kingdom': 'GB', 'uk': 'GB', 'britain': 'GB', 'great britain': 'GB', 'england': 'GB',
  'united states': 'US', 'usa': 'US', 'us': 'US', 'america': 'US',
  'uruguay': 'UY', 'uzbekistan': 'UZ', 'venezuela': 'VE', 'vietnam': 'VN',
  'viet nam': 'VN', 'yemen': 'YE', 'zambia': 'ZM', 'zimbabwe': 'ZW',
  'kosovo': 'XK', 'gaza': 'PS',
};

/** Get all known country name strings (lowercase). Used by entity extraction. */
export function getAllCountryNames(): string[] {
  return Object.keys(NAME_TO_CODE);
}

/** Look up ISO alpha-2 code from a country name. Returns null if not found. */
export function getCountryCodeFromName(name: string): string | null {
  const lower = name.trim().toLowerCase();
  return NAME_TO_CODE[lower] ?? null;
}

/** Get all known ISO alpha-2 country codes. */
export function getAllCountryCodes(): string[] {
  return Object.keys(CENTROIDS);
}

/**
 * Look up country centroid by ISO alpha-2 code or country name.
 * Returns [lat, lng] or null if not found.
 */
export function getCountryCentroid(input: string): [number, number] | null {
  if (!input) return null;

  // Try direct code lookup (uppercase)
  const upper = input.trim().toUpperCase();
  if (CENTROIDS[upper]) return CENTROIDS[upper];

  // Try name → code lookup (lowercase)
  const lower = input.trim().toLowerCase();
  const code = NAME_TO_CODE[lower];
  if (code && CENTROIDS[code]) return CENTROIDS[code];

  return null;
}
